import { Switch } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {
  primaryColor,
  secondaryColor,
  whiteColor,
} from '@themes/defaultThemeProps';

export const AntSwitch = withStyles(() => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: secondaryColor[1],
    '&$checked': {
      transform: 'translateX(12px)',
      color: whiteColor,
      '& + $track': {
        opacity: 1,
        backgroundColor: primaryColor[0],
        borderColor: primaryColor[0],
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${primaryColor[0]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: whiteColor,
  },
  checked: {},
}))(Switch);
